export const ageGroups = [
  { label: 'Children', value: 'Children' },
  { label: 'Adolescents', value: 'Adolescents' },
  { label: 'University', value: 'University' },
  { label: 'Adults', value: 'Adults' },
];

export const desireStartDateOptions = [
  { label: 'January', value: 'January' },
  { label: 'February', value: 'February' },
  { label: 'March', value: 'March' },
  { label: 'April', value: 'April' },
  { label: 'May', value: 'May' },
  { label: 'June', value: 'June' },
  { label: 'July', value: 'July' },
  { label: 'August', value: 'August' },
  { label: 'September', value: 'September' },
  { label: 'October', value: 'October' },
  { label: 'November', value: 'November' },
  { label: 'December', value: 'December' },
  { label: 'January', value: 'January' },
];
export const desiredCountry = [
  { label: 'China', value: 'China' },
  { label: 'Indonesia', value: 'Indonesia' },
  { label: 'Japan', value: 'Japan' },
  { label: 'South Korea', value: 'South Korea' },
  { label: 'Taiwan', value: 'Taiwan' },
  { label: 'Thailan', value: 'Thailan' },
  { label: 'Vietnam', value: 'Vietnam' },
];
export const nationalities = [
  { label: 'United States of America', value: 'United States' },
  { label: 'United Kingdom', value: 'United Kingdom' },
  { label: 'Canada', value: 'Canada' },
  { label: 'Ireland', value: 'Ireland' },
  { label: 'South Africa', value: 'South Africa' },
  { label: 'New Zealand', value: 'New Zealand' },
  { label: 'Australia', value: 'Australia' },
  { label: 'Other', value: 'Other' },
];
export const educationOptions = [
  { label: 'High School or equivalent', value: 'High School' },
  { label: 'Bachelors', value: 'Bachelors' },
  { label: 'Masters', value: 'Masters' },
  { label: 'Phd', value: 'Phd' },
];

export const experienceOptions = [
  { label: '0', value: '0' },
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' },
  { label: '6', value: '6' },
  { label: '7', value: '7' },
  { label: '8', value: '8' },
  { label: '9', value: '9' },
  { label: '10+', value: '10+ ' },
];
